import type { ReactNode } from "react";
import { createElement } from "react";
import { InstantSearch } from "react-instantsearch";

import { getAlgoliaIndex, searchClient } from "./client";

interface IProps {
  children: ReactNode;
  initialQuery?: string;
  indexName?: string;
}

export default function AlgoliaProvider({ children, initialQuery = "", indexName }: IProps) {
  const index = indexName ?? getAlgoliaIndex();

  return createElement(
    InstantSearch,
    {
      future: { preserveSharedStateOnUnmount: true },
      indexName: index,
      initialUiState: { [index]: { query: initialQuery } },
      insights: false,
      searchClient,
    },
    children,
  );
}
